
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import React, { Component } from 'react';
import Login from '../Login/login';
import Root from '../Root/root';

import Exception from '../Exception/exception';
import cookie from 'react-cookies'

class App extends Component {
  constructor(props){
    super(props);
    this.state={
      loginPage:[],
      rootScreen:[],
      userName: '', 
      password: '',
      role: '',
      security : cookie.load('user'),
    }
  }

  authenticate(){
    return new Promise(resolve => setTimeout(resolve, 2000))
  }

  componentDidMount(){
    /*localStorage.clear();
    localStorage.setItem("user", null);
    cookie.remove('user', { path: '/'}) ;*/
    var loginPage =[];
    var rootScreen = [];
    
    if (this.state.security===undefined || this.state.security===null) {
      loginPage.push(<Login appContext={this} key={"login-screen"}/>);
      this.setState({ loginPage:loginPage })
    } 
    else
    {
      rootScreen.push(<Root appContext={this} key="root-screen"/>);
      this.setState({ loginPage:[],rootScreen:rootScreen })
    }
  }

  componentWillMount(){
    this.authenticate().then(() => {
      const ele = document.getElementById('ipl-progress-indicator')
      if(ele){
        ele.classList.add('available')
      }
    })
  }

  render() {

    return (
      <Exception>
        <div className="App noselect">
        <ToastContainer autoClose={3000} position={toast.POSITION.TOP_RIGHT}/>
          {this.state.loginPage}
          {this.state.rootScreen}
        </div>
      </Exception>
    );
  }
}

export default App;
